(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company-invoice-info', {
                parent: 'entity',
                url: '/company-invoice-info?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyInvoiceInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-invoice-info/company-invoice-infos.html',
                        controller: 'CompanyInvoiceInfoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyInvoiceInfo');
                        $translatePartialLoader.addPart('companyInvoiceInfoItem');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('company-invoice-info.new', {
                parent: 'company-invoice-info',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-invoice-info/company-invoice-info-dialog.html',
                        controller: 'CompanyInvoiceInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    managerType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company-invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('company-invoice-info');
                    });
                }]
            })
            .state('company-invoice-info.edit', {
                parent: 'company-invoice-info',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-invoice-info/company-invoice-info-dialog.html',
                        controller: 'CompanyInvoiceInfoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CompanyInvoiceInfo', function (CompanyInvoiceInfo) {
                                return CompanyInvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company-invoice-info.delete', {
                parent: 'company-invoice-info',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-invoice-info/company-invoice-info-delete-dialog.html',
                        controller: 'CompanyInvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyInvoiceInfo', function (CompanyInvoiceInfo) {
                                return CompanyInvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company-invoice-info', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
